export default "__VITE_ASSET__DN$lnQTo__"